export default {
    'name': 'graphic',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<g clip-path=\'url(#clip0_3981_98940)\'><path d=\'M6.16675 17.4167L7.83341 13.6667L9.50008 17.4167L12.0001 10.75L14.5001 17.4167L18.2501 5.75\' stroke=\'#026958\' stroke-width=\'1.5\' stroke-linecap=\'round\' stroke-linejoin=\'round\'/><path d=\'M2 22V2H22V22H2Z\' stroke=\'#026958\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/></g><defs><clipPath id=\'clip0_3981_98940\'><rect width=\'24\' height=\'24\' fill=\'white\'/></clipPath></defs>'
}
